import { memo } from "react";
import { Link } from "react-router-dom";
import images from "../../../assets/images";

const InstructorCard = ({ data }) => {
  const img = data?.picture?.startsWith("https")
    ? data?.picture
    : images.dummy.course;

  return (
    <div className="category-card border rounded-3 overflow-hidden shadow-sm h-100">
      <img
        src={img}
        alt={`${data?.first_name} ${data?.last_name}`}
        className="img-fluid category-card-img"
        style={{ objectFit: "cover" }}
      />
      <div className="category-card-inner">
        <div className="d-flex align-items-md-center gap-2">
          <div className="flex-grow-1 overflow-hidden">
            <h6
              className="text-uppercase mb-1 text-truncate"
              style={{ maxWidth: "100%" }}
            >
              {data?.first_name} {data?.last_name}
            </h6>
            <p
              className="text-muted mb-0 text-truncate"
              style={{ maxWidth: "100%" }}
            >
              {data?.email}
            </p>
          </div>
          <div className="flex-shrink-0">
            <Link to={`/instructor/${data?._id}`} className="arrow-btn">
              <i className="fas fa-angle-right" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(InstructorCard);
